"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationSearchQuerySchema = exports.ApplicationIdPathParamsSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../../schemas");
exports.ApplicationIdPathParamsSchema = zod_1.z.object({ applicationId: schemas_1.UUIDSchema });
exports.ApplicationSearchQuerySchema = schemas_1.PaginationQuerySchema;
